import Vue from 'vue'
import { omit } from 'lodash'

// State
const state = {
  isLoading: false,
  isSaving: false,
  data: [],
  selectedSign: null
}

// Mutations
const fetchSignsRequest = 'fetchSignsRequest'
const fetchSignsResponse = 'fetchSignsResponse'
export const addSignToList = 'addSignToList'
export const removeSignFromList = 'removeSignFromList'
export const selectSignToCopy = 'selectSignToCopy'
export const unselectSignToCopy = 'unselectSignToCopy'
const copySignRequest = 'copySignRequest'
const copySignResponse = 'copySignResponse'
const saveSignRequest = 'saveSignRequest'
const saveSignResponse = 'saveSignResponse'

const mutations = {
  [fetchSignsRequest] (state) {
    state.isLoading = true
  },
  [fetchSignsResponse] (state, signs) {
    state.isLoading = false
    state.data = signs
  },
  [addSignToList] (state, sign) {
    const index = state.data.findIndex(({ id }) => id === sign.id)
    if (index > -1) {
      state.data = [
        ...state.data.slice(0, index),
        { ...state.data[index], ...sign },
        ...state.data.slice(index + 1)
      ]
    } else {
      state.data = [sign, ...state.data]
    }
  },
  [removeSignFromList] (state, sign) {
    state.data = state.data.filter(({ id }) => id !== sign.id)
  },
  [selectSignToCopy] (state, sign) {
    state.selectedSign = sign
  },
  [unselectSignToCopy] (state) {
    state.selectedSign = null
  },
  [copySignRequest] (state) {
    state.isSaving = true
  },
  [copySignResponse] (state) {
    state.isSaving = false
  },
  [saveSignRequest] (state) {
    state.isSaving = true
  },
  [saveSignResponse] (state, sign) {
    state.isSaving = false
  }
}

// Actions
export const fetchSigns = 'fetchSigns'
export const archiveSign = 'archiveSign'
export const unarchiveSign = 'unarchiveSign'
export const saveSignInList = 'saveSignInList'
export const copySign = 'copySign'

const actions = {
  [fetchSigns]: ({ commit, dispatch }) => {
    commit(fetchSignsRequest)
    return Vue.http.get(`${SERVER_URL}/signs`).then(({ data: signs }) => {
      commit(fetchSignsResponse, signs)
    })
  },
  [saveSignInList]: ({ commit }, sign) => {
    commit(saveSignRequest)
    return Vue.http
      .put(`${SERVER_URL}/signs/${sign.id}`, omit(sign, 'variants'))
      .then(({ data: sign }) => {
        commit(saveSignResponse, sign)
        commit(addSignToList, sign)
      })
  },
  [archiveSign]: ({ commit, dispatch }, sign) => {
    dispatch(saveSignInList, { ...sign, isArchived: true })
  },
  [unarchiveSign]: ({ commit, dispatch }, sign) => {
    dispatch(saveSignInList, { ...sign, isArchived: false })
  },
  [copySign]: ({ commit }, { sign, newName, newSignType }) => {
    commit(copySignRequest)
    return Vue.http
      .post(`${SERVER_URL}/copySign/${sign.id}`, { newName, newSignType })
      .then(({ data: sign }) => {
        commit(copySignResponse)
        commit(addSignToList, sign)
      })
  }
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/signs.js